import { __exportAll } from "./_virtual/_rolldown/runtime.js";
//#region src/position-helper.ts
var position_helper_exports = /* @__PURE__ */ __exportAll({ calculateFloatingPosition: () => calculateFloatingPosition });
/**
* Calculates a fixed position for a floating element relative to an anchor.
*
* - Vertical: prefers `preferY` direction, falls back to opposite, then top of viewport.
* - Horizontal: left-aligned with anchor, falls back to right-aligned within viewport.
*/
function calculateFloatingPosition(options) {
	const { anchor, floating, gap = 4, preferY = "above" } = options;
	const viewportWidth = options.viewport?.width ?? document.documentElement.clientWidth;
	const viewportHeight = options.viewport?.height ?? document.documentElement.clientHeight;
	const fitsAbove = anchor.top >= floating.height + gap;
	const fitsBelow = anchor.bottom + floating.height + gap <= viewportHeight;
	let top;
	if (preferY === "above") {
		if (fitsAbove) top = anchor.top - floating.height - gap;
		else if (fitsBelow) top = anchor.bottom + gap;
		else top = gap;
	} else if (fitsBelow) top = anchor.bottom + gap;
	else if (fitsAbove) top = anchor.top - floating.height - gap;
	else top = gap;
	const fitsLeft = anchor.left + floating.width <= viewportWidth;
	let left;
	if (fitsLeft) left = anchor.left;
	else left = Math.max(gap, viewportWidth - floating.width - gap);
	return {
		top,
		left
	};
}
//#endregion
export { calculateFloatingPosition, position_helper_exports };
